

















































import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { ForgotPasswordModel } from '@/models/admin/users';
import { VFields } from '@/models/v-fields';
import { Utils } from '@/helper/utils';
import { Base } from '@/components/common/base';
import { accountService } from '@/shared';

@Component({})
export default class ResetPasswordPage extends Base {
  public resetPasswordModel: ForgotPasswordModel = {
    email: '',
  };
  public resetPasswordFields: Array<VFields<string>> = [];
  public form: any = {};

  // public accountService: AccountService = new AccountService();
  public requestProgress: boolean = false;

  public logoPath: string ;

public created(){
  // this.logoPath = require("@/assets/"+Utils.AppEnvironmentName+"logo-1.png");
  this.logoPath = Utils.blobBaseUrl+"logo-1.png";
}

  public mounted() {
    this.setResetPasswordFormFields();
  }

  public setResetPasswordFormFields(): void {
    this.resetPasswordFields = [
      {
        key: 'email',
        required: true,
        type: 'v-alynk-text-field',
        validators: {
          email: (field, model, next) => {
            next(Utils.EmailRegex.test(model[field.key]));
          },
        },
        templateOptions: {
          validations: 'required|email',
          label: this.$parent.$t('forgotPassword.lblRegisteredEmail') as string,
          disabled: false,
          type: 'email',
          rules: [
            (v) =>
              !!v ||
              (this.$parent.$t('forgotPassword.txtFieldsRequired') as string),
          ],
        },
      },
    ];
  }

  public ForgotValidation(): Vue & { validate: () => boolean } {
    return this.$refs.forgotForm as Vue & { validate: () => boolean };
  }

  public async submit(): Promise<void> {
    try {
      if (this.ForgotValidation().validate()) {
        this.requestProgress = true;
        await accountService.forgetPassword(this.resetPasswordModel);
        this.resetPasswordModel.email = '';
        this.showAlert(
          true,
          this.$t('forgotPassword.alertResetPasswordEmailSent')
        );
      }
    } finally {
      this.requestProgress = false;
    }
  }
}
